var React = require('react');

function RefineInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Refine/16px","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M1,4 L15,4","id":"Path-11","stroke":"#000000","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("rect",{"id":"Rectangle","stroke":"#000000","fill":"#000000","x":"3.5","y":"1.5","width":"5","height":"5","rx":"2.5","key":1}),React.createElement("path",{"d":"M1,12 L15,12","id":"Path-10","stroke":"#171717","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":2}),React.createElement("rect",{"id":"Rectangle","stroke":"#000000","fill":"#000000","x":"7.5","y":"9.5","width":"5","height":"5","rx":"2.5","key":3})]));
}

RefineInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = RefineInline;

RefineInline.default = RefineInline;
